import packageJson from "../../package.json";

export interface VersionInfo {
  version: string;
  buildDateTime: string;
  environment: string;
}

export const getVersionInfo = (): VersionInfo => {
  const now = new Date();
  return {
    version: packageJson.version,
    buildDateTime: now.toLocaleString(),
    environment: import.meta.env.MODE || "development",
  };
};

export const getDisplayVersion = (): string => {
  const { version, environment } = getVersionInfo();
  if (environment === "development") {
    return `v${version}-dev`;
  }
  return `v${version}`;
};

export const getFullVersionString = (): string => {
  const { version, buildDateTime, environment } = getVersionInfo();
  return `v${version} (${environment}) - Built: ${buildDateTime}`;
};
